import {SyncState} from '@docma-mm-core/model/sync-state/sync-state';
import {FaultData} from '@docma-mm-core/fault/fault-data';
import {LoadState} from '@docma-mm-core/model/load-state/load-state';
import {ActivityData} from '@docma-mm-core/activity/activity';
import {AttachmentData} from '@docma-mm-core/attachment/attachment';
import {User} from '@docma-mm-core/user/user';

export class SyncResult {
  constructor(init?: Partial<SyncResult>) {
    if (init)  {
      Object.assign(this, init);
    }
  }

  syncState: SyncState;

  faultLoadStates: LoadState<FaultData>[] = [];
  attachmentsLoadStates: LoadState<AttachmentData>[] = [];
  activityLoadStates: LoadState<ActivityData>[] = [];
  activityAttachmentsLoadStates: LoadState<AttachmentData>[] = [];

  modifiedOn?: Date;
  modifier?: User;
}
